var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form-item',{attrs:{"label":"品类:"}},[_c('el-autocomplete',{staticClass:"inline-input",attrs:{"fetch-suggestions":_vm.querySearch,"placeholder":"请输入","size":"mini"},on:{"select":_vm.handleSelect,"input":_vm.changedInput},model:{value:(_vm.selectedItem),callback:function ($$v) {_vm.selectedItem=$$v},expression:"selectedItem"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }